export const API = {  
    GET_MEETING_DATA: {
      path: '/hooks/meet-info',
      method: 'GET',
    },  
};